import { LOGOUT, SET_SESSION } from "../actions/actionTypes";
import { Session } from "../type";

const initialState: Session = {
    sessionToken: undefined,
    email: undefined,
    _id: undefined,
};

export default function sessionReducer(state: Session = initialState, action: any) {
    switch (action.type) {
        case SET_SESSION:
            return { ...state, ...action.payload };
        case LOGOUT:
            return { ...initialState }
        default:
            return state;
    }
}
